export default __webpack_public_path__ + "static/media/Julie.013f9794.jpg";